export default "__VITE_ASSET__h3nuv1jW__"